/**
 * Yılbaşı & Kar Yağışı Efekti
 */

function createChristmasSnowEffect(options = {}) {
  // Mobil cihaz kontrolü
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;
  
  // Hareket hassasiyeti kontrolü (erişilebilirlik)
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  // Eğer kullanıcı hareket azaltma tercih ediyorsa, efekti başlatma
  if (prefersReducedMotion && options.respectMotionPreference !== false) {
    return {
      stop: () => {},
      updateSettings: () => {},
      pause: () => {},
      resume: () => {}
    };
  }
  
  const settings = {
    particleCount: options.partikülSayısı || options.particleCount || (isMobile ? 30 : 60),
    enableStars: options.yıldızlarıAktifEt !== false && options.enableStars !== false,
    enableGifts: options.hediyeleriAktifEt !== false && options.enableGifts !== false,
    enableSparkles: options.ışıltılarıAktifEt !== false && options.enableSparkles !== false,
    enablePulse: options.parlamaEfekti !== false && options.enablePulse !== false,
    sizeMultiplier: options.partikülBoyutu || options.sizeMultiplier || 1,
    zIndex: options.zIndex || 9999,
    respectMotionPreference: (options.hareketAzaltmaTercihi !== false && options.respectMotionPreference !== false)
  };

  const canvas = document.createElement('canvas');
  canvas.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: ${settings.zIndex};
    background: none;
    opacity: 1;
  `;
  canvas.setAttribute('aria-hidden', 'true'); // Ekran okuyucular için gizle
  canvas.setAttribute('role', 'presentation');
  document.body.appendChild(canvas);

  const ctx = canvas.getContext('2d', { alpha: true }); // Performans optimizasyonu
  let particles = [];
  let animationId;
  let isPageVisible = true;
  let isPaused = false;

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);

  // Sayfa görünürlük kontrolü (tab değişiminde animasyonu durdur)
  const handleVisibilityChange = () => {
    isPageVisible = !document.hidden;
    if (!isPageVisible) {
      cancelAnimationFrame(animationId);
    } else if (!isPaused) {
      animate();
    }
  };
  document.addEventListener('visibilitychange', handleVisibilityChange);

  // Particle sınıfı (Parçacık)
  class Particle {
    constructor() {
      this.types = ['snowflake', 'star', 'gift', 'sparkle'];
      // Varsayılan olasılık ağırlıkları
      this.weights = [0.6, 0.15, 0.1, 0.15]; 
      this.reset();
      this.y = Math.random() * canvas.height; // İlk yükleme için rastgele y pozisyonu
      this.rotation = Math.random() * Math.PI * 2;
    }

    selectType() {
      const rand = Math.random();
      let cumulative = 0;
      
      // Ayarlara göre tip ağırlıklarını sıfırla
      if (!settings.enableStars) this.weights[1] = 0;
      if (!settings.enableGifts) this.weights[2] = 0;
      if (!settings.enableSparkles) this.weights[3] = 0;
      
      const total = this.weights.reduce((a, b) => a + b, 0);
      
      // Ağırlıklı rastgele tip seçimi
      for (let i = 0; i < this.types.length; i++) {
        cumulative += this.weights[i] / total;
        if (rand < cumulative) {
          return this.types[i];
        }
      }
      return 'snowflake'; // Varsayılan: Kar tanesi
    }

    reset() {
      this.type = this.selectType();
      this.x = Math.random() * canvas.width;
      this.y = -20; // Ekranın üstünden başla
      this.size = this.getSize();
      this.speed = Math.random() * 2 + 0.5;
      this.drift = Math.random() * 1.5 - 0.75; // Yatay sürüklenme
      this.opacity = Math.random() * 0.4 + 0.6;
      this.rotationSpeed = (Math.random() - 0.5) * 0.05;
      this.swingAmplitude = Math.random() * 1 + 0.5; // Salınım genliği
      this.swingSpeed = Math.random() * 0.02 + 0.01; // Salınım hızı
      this.swingOffset = Math.random() * Math.PI * 2;
      this.color = this.getColor();
      this.pulseSpeed = Math.random() * 0.05 + 0.02; // Titreşim hızı (parlama efekti)
      this.pulseOffset = Math.random() * Math.PI * 2;
    }

    getSize() {
      let baseSize;
      switch(this.type) {
        case 'snowflake': baseSize = Math.random() * 2 + 1; break;
        case 'star': baseSize = Math.random() * 4 + 3; break;
        case 'gift': baseSize = Math.random() * 6 + 4; break;
        case 'sparkle': baseSize = Math.random() * 2 + 1; break;
        default: baseSize = 2;
      }
      return baseSize * settings.sizeMultiplier;
    }

    getColor() {
      switch(this.type) {
        case 'snowflake': return '#ffffff';
        case 'star': return ['#FFD700', '#FFA500', '#FFFF00'][Math.floor(Math.random() * 3)];
        case 'gift': return ['#FF0000', '#00FF00', '#0000FF', '#FFD700'][Math.floor(Math.random() * 4)];
        case 'sparkle': return ['#FF69B4', '#00CED1', '#FFD700', '#FF1493'][Math.floor(Math.random() * 4)];
        default: return '#ffffff';
      }
    }

    update() {
      // Salınım hareketi (Yavaş rüzgar/dalgalanma)
      this.x += Math.sin(this.y * this.swingSpeed + this.swingOffset) * this.swingAmplitude * 0.1;
      
      this.y += this.speed;
      this.x += this.drift;
      this.rotation += this.rotationSpeed;

      // Ekran dışına çıkınca yeniden başlat
      if (this.y > canvas.height + 20) {
        this.reset();
      }

      // Yatay döngü (sağdan çıkıp soldan girme)
      if (this.x > canvas.width + 20) {
        this.x = -20;
      } else if (this.x < -20) {
        this.x = canvas.width + 20;
      }
    }

    draw() {
      ctx.save();
      ctx.translate(this.x, this.y);
      ctx.rotate(this.rotation);
      
      // Parlama/Titreşim efekti (Büyüklükte hafif değişim)
      if (settings.enablePulse) {
        const pulse = Math.sin(Date.now() * this.pulseSpeed + this.pulseOffset) * 0.2 + 0.8;
        ctx.globalAlpha = this.opacity * pulse;
      } else {
        ctx.globalAlpha = this.opacity;
      }

      // Partikül tipine göre çizim fonksiyonunu çağır
      switch(this.type) {
        case 'snowflake':
          this.drawSnowflake();
          break;
        case 'star':
          this.drawStar();
          break;
        case 'gift':
          this.drawGift();
          break;
        case 'sparkle':
          this.drawSparkle();
          break;
      }

      ctx.restore();
    }

    // Kar Tanesi Çizimi (Daha doğal, basit daireler)
    drawSnowflake() {
      ctx.fillStyle = this.color;
      ctx.shadowBlur = 3;
      ctx.shadowColor = this.color;
      
      // Ana daire (kar tanesi)
      ctx.beginPath();
      ctx.arc(0, 0, this.size, 0, Math.PI * 2);
      ctx.fill();
      
      // Hafif bulanık kenarlık efekti için
      ctx.globalAlpha = this.opacity * 0.3;
      ctx.beginPath();
      ctx.arc(0, 0, this.size * 1.3, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = this.opacity;
      
      ctx.shadowBlur = 0;
    }

    // Yıldız Çizimi (5 köşeli)
    drawStar() {
      ctx.fillStyle = this.color;
      ctx.shadowBlur = 10;
      ctx.shadowColor = this.color;
      
      ctx.beginPath();
      for (let i = 0; i < 5; i++) {
        // 5 köşeli yıldız için açı hesaplaması
        const angle = (i * 4 * Math.PI / 5) - Math.PI / 2;
        const x = Math.cos(angle) * this.size;
        const y = Math.sin(angle) * this.size;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }
      ctx.closePath();
      ctx.fill();
      
      ctx.shadowBlur = 0;
    }

    // Hediye Kutusu Çizimi (Kare ve Kurdele)
    drawGift() {
      ctx.shadowBlur = 5;
      ctx.shadowColor = 'rgba(0,0,0,0.3)';
      
      // Kutu
      ctx.fillStyle = this.color;
      ctx.fillRect(-this.size/2, -this.size/2, this.size, this.size);
      
      // Kurdele
      ctx.fillStyle = '#FFD700'; // Altın sarısı kurdele
      ctx.fillRect(-this.size/2, -this.size/8, this.size, this.size/4); // Yatay
      ctx.fillRect(-this.size/8, -this.size/2, this.size/4, this.size); // Dikey
      
      // Fiyonk
      ctx.beginPath();
      ctx.arc(-this.size/4, -this.size/2, this.size/4, 0, Math.PI * 2);
      ctx.arc(this.size/4, -this.size/2, this.size/4, 0, Math.PI * 2);
      ctx.fill();
      
      ctx.shadowBlur = 0;
    }

    // Işıltı Çizimi (Çizgi ve merkez parlama)
    drawSparkle() {
      ctx.shadowBlur = 8;
      ctx.shadowColor = this.color;
      
      // Çizgiler (Artı ve çarpı şeklinde)
      for (let i = 0; i < 4; i++) {
        ctx.save();
        ctx.rotate((Math.PI / 4) * i); // 45 derecelik açılarla
        ctx.beginPath();
        ctx.moveTo(0, -this.size * 0.7);
        ctx.lineTo(0, this.size * 0.7);
        ctx.lineWidth = this.size / 3;
        ctx.strokeStyle = this.color;
        ctx.stroke();
        ctx.restore();
      }
      
      // Merkez parlama (radyal gradyan)
      const gradient = ctx.createRadialGradient(0, 0, 0, 0, 0, this.size);
      gradient.addColorStop(0, this.color);
      gradient.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(0, 0, this.size, 0, Math.PI * 2);
      ctx.fill();
      
      ctx.shadowBlur = 0;
    }
  }

  // Partikülleri oluştur
  for (let i = 0; i < settings.particleCount; i++) {
    particles.push(new Particle());
  }

  // Animasyon döngüsü
  let lastFrameTime = Date.now();
  const targetFPS = isMobile ? 30 : 60; // Mobilde daha düşük FPS
  const frameInterval = 1000 / targetFPS;
  
  function animate() {
    if (isPaused || !isPageVisible) return;
    
    const now = Date.now();
    const elapsed = now - lastFrameTime;
    
    // FPS sınırlama (özellikle mobil için)
    if (elapsed > frameInterval) {
      lastFrameTime = now - (elapsed % frameInterval);
      
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach(particle => {
        particle.update();
        particle.draw();
      });
    }

    animationId = requestAnimationFrame(animate);
  }

  // Sayfa yüklendikten sonra animasyonu başlat (sayfa yüklenme süresini etkilememesi için)
  if (document.readyState === 'complete') {
    setTimeout(() => animate(), 100);
  } else {
    window.addEventListener('load', () => {
      setTimeout(() => animate(), 100);
    });
  }

  // Dışarıya açılan kontrol fonksiyonları (Durdurma, Ayar güncelleme, Pause/Resume)
  return {
    stop: function() {
      isPaused = true;
      cancelAnimationFrame(animationId);
      canvas.remove();
      
      // Tüm event listener'ları temizle
      window.removeEventListener('resize', resizeCanvas);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      
      // Bellek temizliği
      particles.length = 0;
      particles = null;
    },
    pause: function() {
      isPaused = true;
      cancelAnimationFrame(animationId);
    },
    resume: function() {
      if (!isPaused) return;
      isPaused = false;
      if (isPageVisible) {
        animate();
      }
    },
    updateSettings: function(newOptions) {
      Object.assign(settings, newOptions);
      
      // Yeni partikül sayısı için yeniden oluşturma gerekebilir
      if (newOptions.particleCount !== undefined || newOptions.partikülSayısı !== undefined) {
        const newCount = newOptions.partikülSayısı || newOptions.particleCount;
        particles.length = 0;
        for (let i = 0; i < newCount; i++) {
          particles.push(new Particle());
        }
      }
    }
  };
}

// 🎉 Sayfa yüklendiğinde efekti otomatik başlat
window.addEventListener('DOMContentLoaded', function() {    
    // Varsayılan ayarlarla başlat
    createChristmasSnowEffect({
        partikülSayısı: 85, // partikül sayısı
        yıldızlarıAktifEt: false, // isteğe bağlı yıldızlar
        hediyeleriAktifEt: false, // isteğe bağlı hediyeler
        ışıltılarıAktifEt: false, // isteğe bağlı ışıltılar
        parlamaEfekti: false, // isteğe bağlı parlama efekti
        partikülBoyutu: 1.5, // (1 = normal, 1.5 = %50 daha büyük, 0.5 = %50 daha küçük)
        hareketAzaltmaTercihi: true // Erişilebilirlik için önemli
    });
});